import { Input } from '@firesoon/antd';
import AntdTextArea from '@firesoon/antd/lib/input/TextArea';
import React, { ForwardRefRenderFunction, forwardRef, useState } from 'react';
import { FSTextAreaProps } from './interface';

const { TextArea } = Input;
const prefix = 'fs-textArea';

const Index: ForwardRefRenderFunction<AntdTextArea, FSTextAreaProps> = (props, ref) => {
  const { value: propsValue, max, className = '', style, onChange: propsOnChange, ...rest } = props;
  const hasNum = max && max > 0;

  const [middleValue, setMiddleValue] = useState('');

  const value = propsValue ?? middleValue;

  const onChange = (e) => {
    propsOnChange?.(e);
    if (!propsValue) {
      setMiddleValue(e.target.value);
    }
  };

  return (
    <div className={prefix} style={style}>
      <TextArea
        placeholder="请输入内容"
        rows={2}
        ref={ref}
        value={value}
        className={`${className} ${hasNum ? `${prefix}-hasNum` : ''}`}
        maxLength={max}
        allowClear
        onChange={onChange}
        {...rest}
      />

      {hasNum && (
        <div className={`${prefix}-wordCount`}>
          {String(value ?? '').length}/{max}
        </div>
      )}
    </div>
  );
};

export default forwardRef(Index);
